(() => {
  const init = () => document.querySelectorAll('[data-review-panel]').forEach(panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const form = panel.querySelector('form');
    const button = panel.querySelector('[data-review-add]');
    const selector = panel.querySelector('[data-review-variant]');
    const status = panel.querySelector('[data-review-status]');
    const failureMessage = document.documentElement.lang.startsWith('he') ? 'לא הצלחנו להוסיף את המוצר לסל. אפשר לנסות שוב.' : 'Unable to add this product. Please try again.';
    selector?.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      panel.querySelector('[data-review-price]').textContent = option.dataset.price;
      const compare = panel.querySelector('[data-review-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      status.textContent = '';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (selector) selector.disabled = true;
      status.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const id = selector ? selector.value : form.elements.id.value;
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'},
          body: JSON.stringify({items:[{id, quantity:1}]})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || failureMessage);
        // Go to the actual cart so all theme cart totals and quantities are fresh.
        window.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message || failureMessage;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (selector) selector.disabled = false;
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
